import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Impuesto from './Impuesto.js';
import ACCESS from '../../../ACCESS.js';

class Impuestos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'impuesto/filter', deleteUrl: 'impuesto/delete', deleteField: 'impuesto_nombre', modUrl: '/Catalogo/Impuesto' },
      TableOp.Table('Impuestos', [
        { label: 'Clave', id: 'impuesto_clave' },
        { label: 'Nombre', id: 'impuesto_nombre' },
        { label: 'Retencion', id: 'impuesto_retencion' },
        { label: 'Traslado', id: 'impuesto_traslado' },
        { label: 'Local o Federal', id: 'impuesto_local_federal' },
        { label: 'Entidad en', id: 'impuesto_entidad' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_IMPUESTOS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_IMPUESTOS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <Impuesto  onSave={() => {this.table()}}></Impuesto>
          }
          {
             
          <this.TableRender  />
          }
        </div>
      </div>
    )
  }
}

export default withRouter(Impuestos)